import { TablePagination } from "@mui/material";
import { useState, useEffect } from "react";

export const Pagination = ({ totalNumItems, onPageChangeNewPosition, onRowsChangeNewDisplayLimit, triggerPageReset = false, onTriggerReset, controlRendered }) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [listStartingIndex, setListStartingIndex] = useState(0);

    useEffect(() => {
        if (controlRendered !== null && !controlRendered) {
            onPageChangeNewPosition(page * rowsPerPage)
            onRowsChangeNewDisplayLimit((page * rowsPerPage) + (Math.min(rowsPerPage, totalNumItems)));
        }

    }, [page, rowsPerPage, totalNumItems, onPageChangeNewPosition, onRowsChangeNewDisplayLimit, controlRendered])

    useEffect(() => {
        if (triggerPageReset) {
            onTriggerReset(false);
            setPage(0);
        }
    }, [triggerPageReset, onTriggerReset, setPage])

    const handleChangePage = (_, newPage) => {
        setPage(newPage);
        onPageChangeNewPosition(newPage * rowsPerPage);
        setListStartingIndex(newPage * rowsPerPage);
    };

    const handleChangeRowsPerPage = (event) => {
        let rowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(rowsPerPage);
        setPage(0);

        let recordsOnPage = Math.min(rowsPerPage, totalNumItems);
        let pageDisplayLimitIndex = listStartingIndex + recordsOnPage;
        onRowsChangeNewDisplayLimit(pageDisplayLimitIndex);
    };

    return (
        <TablePagination
            component="div"
            count={totalNumItems}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
    )
};